<template>
    <div
        v-if="item.image"
        :class="sizeClasses"
        class="rounded-lg self-start overflow-hidden flex-shrink-0"
    >
        <img
            :alt="item.name"
            :src="`${item.image}/-/format/auto/-/resize/${pixelSize}x/`"
            :srcset="srcSet"
            class="object-cover w-full h-full"
        />
    </div>
    <div v-else :class="sizeClasses"></div>
</template>

<script>
export default {
    name: 'CartImage',
    props: {
        item: {
            type: Object,
            required: true
        },
        size: {
            type: String,
            required: false,
            default: 'md'
        }
    },
    data() {
        return {
            tailwindSizeClass: {
                1: 'w-10 h-10',
                2: 'w-11 h-11',
                3: 'w-12 h-12',
                4: 'w-14 h-14',
                5: 'w-16 h-16',
                6: 'w-20 h-20',
                7: 'w-24 h-24',
                8: 'w-28 h-28',
                9: 'w-32 h-32',
                10: 'w-36 h-36',
                11: 'w-40 h-40',
                12: 'w-44 h-44',
                13: 'w-48 h-48',
                14: 'w-52 h-52',
                15: 'w-56 h-56'
            }
        };
    },
    computed: {
        sizeClasses() {
            if (!this.size) return 'w-14 h-14'; // Default to md size if size not set

            if (['sm', 'md', 'lg'].includes(this.size)) {
                switch (this.size) {
                    case 'sm':
                        return 'w-12 h-12';
                    case 'lg':
                        return 'w-16 h-16';
                    case 'md':
                    default:
                        return 'w-14 h-14';
                }
            }

            const size = parseInt(this.size, 10);

            if (!isNaN(size) && size > 0 && size < 16) {
                return this.tailwindSizeClass[size];
            }

            return 'w-14 h-14';
        },
        pixelSize() {
            if (!this.size) return 56; // Default to md size if size not set

            if (['sm', 'md', 'lg'].includes(this.size)) {
                switch (this.size) {
                    case 'sm':
                        return 40;
                    case 'lg':
                        return 64;
                    case 'md':
                    default:
                        return 56;
                }
            }

            const size = parseInt(this.size, 10);

            if (!isNaN(size) && size > 0 && size < 16) {
                const regex = /^w-(\d+)\s+h-(\d+)$/;
                const match = this.sizeClasses.match(regex);

                if (!match || match.length <= 1) {
                    return 56;
                }

                return parseInt(match[1], 10) * 4;
            }

            return 56;
        },
        srcSet() {
            const base = this.item.image;
            const resize1x = this.pixelSize;
            const resize2x = this.pixelSize * 2;
            const resize3x = this.pixelSize * 3;
            return `${base}/-/resize/${resize1x}x/-/format/auto/ 1x, ${base}/-/resize/${resize2x}x/-/format/auto/ 2x, ${base}/-/resize/${resize3x}x/-/format/auto/ 3x`;
        }
    }
};
</script>
